import { type ComponentProps } from 'react';

import type { Icons } from '@/assets/icons/icons';
import type { KeyName } from '@/lib/key';
import { cn } from '@/lib/utils';

import { FeedKeyTooltip } from './FeedKeyTooltip';
import { FEED_ACTION_BUTTON_CLASS } from './feedStyles';

const LABELLED_CLASS = `${FEED_ACTION_BUTTON_CLASS} h-[calc(28*var(--ac-u))] gap-[calc(5*var(--ac-u))] px-[calc(9*var(--ac-u))] text-[length:calc(12.5*var(--ac-u))]`;

const ICON_ONLY_CLASS = `${FEED_ACTION_BUTTON_CLASS} size-[calc(28*var(--ac-u))]`;

export const FeedRowAction = ({
  icon: Icon,
  label,
  accessibleLabel,
  labelled = false,
  hotkey,
  className,
  ...buttonProps
}: {
  icon?: (typeof Icons)[keyof typeof Icons];
  label: string;
  accessibleLabel?: string;
  labelled?: boolean;
  hotkey?: readonly KeyName[];
} & ComponentProps<'button'>) => {
  const button = (
    <button
      {...buttonProps}
      type="button"
      aria-label={accessibleLabel ?? (labelled ? undefined : label)}
      className={cn(
        'pointer-events-auto',
        labelled ? LABELLED_CLASS : ICON_ONLY_CLASS,
        className
      )}
    >
      {Icon ? (
        <Icon
          aria-hidden="true"
          className={
            labelled
              ? 'size-[calc(13*var(--ac-u))]'
              : 'size-[calc(14*var(--ac-u))]'
          }
        />
      ) : null}
      {labelled ? label : null}
    </button>
  );
  return labelled ? (
    button
  ) : (
    <FeedKeyTooltip label={label} keys={hotkey}>
      {button}
    </FeedKeyTooltip>
  );
};
